export type ClientErrorSeverity = "low" | "med" | "high";

export type ClientErrorVerdict = {
  severity: ClientErrorSeverity;
  drop: boolean;
};

export const DROP_ERROR_NEEDLES = [
  "resizeobserver loop",
  "chrome-extension://",
  "moz-extension://",
  "safari-extension://",
  "/api/issues",
  "errorcapture",
  "components/system/errorcapture",
] as const;

export const HIGH_ERROR_NEEDLES = [
  "typeerror",
  "referenceerror",
  "is not a function",
  "cannot read prop",
  "undefined is not",
] as const;

export const LOW_ERROR_NEEDLES = [
  "load failed",
  "failed to fetch",
  "networkerror",
  "fetch failed",
  "network request failed",
  "chunkloaderror",
  "loading chunk",
  "dynamically imported module",
  "importing a module script failed",
] as const;

export function classifyClientError(
  message: string,
  stack?: string | null,
): ClientErrorVerdict {
  const haystack = `${message}\n${stack ?? ""}`.toLowerCase();

  if (
    message.trim() === "Script error." ||
    DROP_ERROR_NEEDLES.some((needle) => haystack.includes(needle))
  ) {
    return { severity: "med", drop: true };
  }

  if (HIGH_ERROR_NEEDLES.some((needle) => haystack.includes(needle))) {
    return { severity: "high", drop: false };
  }

  if (LOW_ERROR_NEEDLES.some((needle) => haystack.includes(needle))) {
    return { severity: "low", drop: false };
  }

  return { severity: "med", drop: false };
}
